module.exports = __webpack_public_path__ + "static/media/apple-pay.141678c0.svg";